import { Users, MessageCircle } from 'lucide-react';
import { StitekPlochy, TlacitkoPlochy, barvyPlochy } from './PlochaUI';
import RadekKolegy, { seraditKolegy } from './RadekKolegy';

const sklonujKolegy = (n) => (n === 1 ? '1 kolega' : n >= 2 && n <= 4 ? `${n} kolegové` : `${n} kolegů`);

/**
 * Plocha „Kolegové" — pod kartou cockpitu, když člověk klepne na dlaždici
 * Kolegové. Nahradila modal „Tým na směně": s kým dnes dělám, zpráva jednomu
 * nebo všem, telefon. Klepnutí na jméno otevře kartu kolegy.
 *
 * Je to rozložená podoba dlaždice — stejný seznam jako „Na směně s tebou"
 * v detailu před směnou, který se při zahájení do dlaždice složí.
 */
export default function KolegovePanel({ tym = [], onZpravaVsem, onZprava, onOtevrit, isDark }) {
    const b = barvyPlochy(isDark);
    const kolegove = seraditKolegy(tym);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: '4px 12px 12px' }}>
            <StitekPlochy Ikona={Users} barva="#0CC0DF" isDark={isDark}
                vpravo={kolegove.length ? sklonujKolegy(kolegove.length) : null}>
                Na směně s tebou
            </StitekPlochy>

            {kolegove.length === 0 ? (
                <div style={{ fontSize: 13, color: b.tlumena, padding: '4px 2px' }}>
                    Dnes nemáš na směně žádného kolegu.
                </div>
            ) : (
                <>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, paddingTop: 2 }}>
                        {kolegove.map((k) => (
                            <RadekKolegy key={k.zamestnanec_id ?? k.id}
                                kolega={k} onZprava={onZprava} onOtevrit={onOtevrit} isDark={isDark} />
                        ))}
                    </div>
                    {onZpravaVsem && kolegove.length > 1 && (
                        <div style={{ display: 'flex', paddingTop: 2 }}>
                            <TlacitkoPlochy isDark={isDark} Ikona={MessageCircle} onClick={onZpravaVsem}>
                                Napsat všem
                            </TlacitkoPlochy>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
